/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleReference
 */
export interface ScheduleReference {
    /**
     * 
     * @type {number}
     * @memberof ScheduleReference
     */
    id: number;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof ScheduleReference
     */
    readonly variables?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Date}
     * @memberof ScheduleReference
     */
    readonly nextRun?: Date;
    /**
     * 
     * @type {number}
     * @memberof ScheduleReference
     */
    readonly type?: ScheduleReferenceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleReference
     */
    readonly enabled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleReference
     */
    readonly lastRun?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ScheduleReference
     */
    readonly every?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReference
     */
    readonly period?: ScheduleReferencePeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReference
     */
    readonly crontabDayOfMonth?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReference
     */
    readonly crontabDayOfWeek?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReference
     */
    readonly crontabHour?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReference
     */
    readonly crontabMinute?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReference
     */
    readonly crontabMonthOfYear?: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduleReference
     */
    readonly job?: number;
}

/**
* @export
* @enum {string}
*/
export enum ScheduleReferenceTypeEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2
}/**
* @export
* @enum {string}
*/
export enum ScheduleReferencePeriodEnum {
    Minutes = 'minutes',
    Hours = 'hours',
    Days = 'days'
}

export function ScheduleReferenceFromJSON(json: any): ScheduleReference {
    return ScheduleReferenceFromJSONTyped(json, false);
}

export function ScheduleReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'variables': !exists(json, 'variables') ? undefined : json['variables'],
        'nextRun': !exists(json, 'next_run') ? undefined : (new Date(json['next_run'])),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'lastRun': !exists(json, 'last_run') ? undefined : (json['last_run'] === null ? null : new Date(json['last_run'])),
        'every': !exists(json, 'every') ? undefined : json['every'],
        'period': !exists(json, 'period') ? undefined : json['period'],
        'crontabDayOfMonth': !exists(json, 'crontab_day_of_month') ? undefined : json['crontab_day_of_month'],
        'crontabDayOfWeek': !exists(json, 'crontab_day_of_week') ? undefined : json['crontab_day_of_week'],
        'crontabHour': !exists(json, 'crontab_hour') ? undefined : json['crontab_hour'],
        'crontabMinute': !exists(json, 'crontab_minute') ? undefined : json['crontab_minute'],
        'crontabMonthOfYear': !exists(json, 'crontab_month_of_year') ? undefined : json['crontab_month_of_year'],
        'job': !exists(json, 'job') ? undefined : json['job'],
    };
}

export function ScheduleReferenceToJSON(value?: ScheduleReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


